import styled from 'styled-components'

export const CardTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const WorldMapContainer = styled.div`
  display: grid;
  grid-template-columns: 0.6fr 0.4fr;
  grid-gap: ${props => props.theme.spacing.sp16};
`

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
`
